module.exports = __webpack_public_path__ + "img/card@2x.9d9a6f8c.png";